import React from 'react';
import { useTranslation } from 'react-i18next';

import { useRevampThemePerformanceReturn } from '../hooks/useThemePerformanceReturn';
import * as S from './OneDayReturnPill.styles';

export const OneDayReturnPill = ({ themeId }: { themeId: string }) => {
  const { t } = useTranslation('widget');

  const { value: revampValue, isNegative: revampIsNegative } =
    useRevampThemePerformanceReturn({
      themeId,
      selectedHorizon: '1D',
    });

  const dataToUse = {
    value: revampValue,
    isNegative: revampIsNegative,
  };

  return (
    <S.RightHeaderWrapper $isNegative={dataToUse.isNegative}>
      <S.RightHeaderReturnValue $isNegative={dataToUse.isNegative}>
        {dataToUse.value}
      </S.RightHeaderReturnValue>
      <S.RightHeaderReturnLabel>
        {t('widget:themeOverview.lastClose')}
      </S.RightHeaderReturnLabel>
    </S.RightHeaderWrapper>
  );
};
